import { useDeviceWidth } from "@vega-core/hooks/useDeviceWidth";

export function useFiltersLength({
  maxShownFilters = 2,
}: {
  maxShownFilters?: number;
}): number {
  const isLg = useDeviceWidth("lg");

  if (isLg) return maxShownFilters;

  // Always show at least 1 filter on mobile unless maxShownFilters is 0
  return Math.min(1, maxShownFilters);
}
